export default "__VITE_ASSET__d72cc752__"